import * as React from 'react';
import FooterComponent from './footerComponent';
import { observer, inject } from 'mobx-react';
import { useWindowScroll } from 'react-use';
import { PopupContainer } from './popup/popupContainer';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';
interface IDefaultLayoutComponentInjectedProps {
  [ROOT_STORE]: RootStore;
};

export const DefaultLayout: React.FC = inject(ROOT_STORE)(observer((props) => {
  const { children } = props;
  const { rootStore: { layoutStore } } = props as IDefaultLayoutComponentInjectedProps;
  const { y } = useWindowScroll();
  if (layoutStore) {
    if (layoutStore.isTopPixed && (y < 30)) {
      layoutStore.isTopPixed = false;
    } else if (!layoutStore.isTopPixed && (y >= 30)) {
      layoutStore.isTopPixed = true;
    }
  }

  React.useEffect(() => {
    const body = document.getElementById('body') as HTMLBodyElement;
    const bodyClassName = layoutStore.bodyClassName;
    body.className = bodyClassName;
  }, [layoutStore.bodyBackgroundType]);

  return (
    <React.Fragment>
      { children }
      <FooterComponent />
      <PopupContainer />
    </React.Fragment>
  )
}));



// WEBPACK FOOTER //
// ./src/components/layout/index.tsx